import { render, staticRenderFns } from "./EditarImagem.vue?vue&type=template&id=14a5cf0a&"
import script from "./EditarImagem.vue?vue&type=script&lang=js&"
export * from "./EditarImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports